import axios from 'axios';

const API_URL = '/api/mwc'; // Sesuaikan dengan URL backend Anda

const getMWCTransactions = async () => {
  try {
    const response = await axios.get(`${API_URL}/transaksi`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createPenerimaanInfak = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/transaksi/penerimaan-infak`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createPenerimaanDanaAmil = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/transaksi/penerimaan-dana-amil`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createPenerimaanZakat = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/transaksi/penerimaan-zakat`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createPenyaluran = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/transaksi/penyaluran`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const createBebanPengelolaan = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/transaksi/beban-pengelolaan`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const updateMWCTransaction = async (id, transactionData) => {
  try {
    const response = await axios.put(`${API_URL}/transaksi/${id}`, transactionData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const deleteMWCTransaction = async (id) => {
  try {
    await axios.delete(`${API_URL}/transaksi/${id}`);
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const getRantingMonitoringData = async () => {
  try {
    const response = await axios.get(`${API_URL}/monitor/ranting`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const getAggregatedReport = async (month, year) => {
  try {
    const response = await axios.get(`${API_URL}/laporan/agregat`, { params: { month, year } });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

const getAkunForMwc = async () => {
  try {
    const response = await axios.get(`${API_URL}/akun`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

export { 
  getMWCTransactions,
  createPenerimaanInfak,
  createPenerimaanDanaAmil,
  createPenerimaanZakat,
  createPenyaluran,
  createBebanPengelolaan,
  updateMWCTransaction,
  deleteMWCTransaction,
  getRantingMonitoringData,
  getAggregatedReport,
  getAkunForMwc
};
